/* global loadStatesAndProvinces, toggleCheckbox, refreshDobDayInput, isOverEighteen, updateIntlPhoneFlag a*/
/* eslint-disable func-names */

/**
 * create_account handles the Swiper and form steps for a new full-page account creation
 * This is part of the new Rider Funnel experience
 */
SC.create_account = (function () {
  var api = {};

  var init = function () {
    if (!$('body').hasClass('new_rider_create_account')) {
      return;
    }

    handleEvents();
  };

  var handleEvents = function  () {
    initializeAccountCreation();
  };

  /**
   * initializeAccountCreation handles all the events for each step of account creation and login page
   *
   * Signup pages have multiple of the same IDs, so we specify a parent class
   * there are multiple signup forms within any given signup page. Why? ¯\_(ツ)_/¯
   * @returns {void}
   */
  var initializeAccountCreation = function () {
    var $form              = $('form.account-creation__form');
    var $backButton        = $('#handle-back');
    var $doneButton        = $('#handle-done');
    var $formError         = $('.global-form__error');
    var $inputs            = $('.account-creation__form__swiper__slide input');
    var $nextButton        = $('#handle-next');
    var $notNewLink        = $('#handle-not-new');
    var $progressBar       = $('#auth-swiper-progress');
    var $analyticsLocation = $('#analytics_location');

    var $dobPlaceholder       = $('#dob_placeholder-input');
    var $locationPlaceholder  = $('#location_placeholder-input');
    var $dobDayInput          = $('.global__input-select-dob_group > #frm-dob_day');
    var $dobMonthInput        = $('.global__input-select-dob_group > #frm-dob_month');
    var $dobYearInput         = $('.global__input-select-dob_group > #frm-dob_year');
    var $countryInput         = $('.global__input-select-location_group > #frm-country');

    var $optSellingContainer  = $('#opt_selling-container');
    var $optSellingCheckbox   = $('#opt_selling-checkbox');
    var $optSellingLabel      = $('#opt_selling-label');
    var $optSellingSpan       = $('#opt_selling-span');

    var $optMarketingContainer  = $('#optout_marketing-container');
    var $optMarketingCheckbox   = $('#optout_marketing-checkbox');
    var $optMarketingLabel      = $('#optout_marketing-label');
    var $optMarketingSpan       = $('#optout_marketing-span');

    var analyticsLocationVal = $analyticsLocation.val();
    var location = (analyticsLocationVal && analyticsLocationVal.length > 0) ? analyticsLocationVal : 'New Rider';

    // set up the default swiper data
    var swiperData = {
      autoplay: false,
      centeredSlides: true,
      loop: false,
      autoplayDisableOnInteraction: false,
      speed: 400,
      freeMode: false,
      slidesPerView: 2,
      spaceBetween: 100,
      onlyExternal: true,
      slideClass: 'account-creation__form__swiper__slide',
      slideActiveClass: 'account-creation__form__swiper__slide--active',
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 50
        },
        1023: {
          slidesPerView: 1
        }
      }
    };

    var swiper = new Swiper('.account-creation__form__swiper-container', swiperData);
    swiper.on('transitionEnd', function () {
      updateInputsStates();
    });

    /**
     * gets the scaleX value as a string to set to a css transform
     * If we have 3 slides, we want the progress bar to be split into 4.
     * If we are on the third slide, the progress should be at 75%.
     * 100% is reached after the done button click
     *
     * @param {boolean} completed indicating if we've reached the last available slide and exiting(done button)
     * @return {string} css scaleX
     */
    var getScaleX = function (completed) {
      // store the total steps
      var totalSteps = swiper.slides.length + 1;
      // get the original scale
      var originalScale = 1 / totalSteps;

      // if this is the first slide return the original scale
      if (swiper.activeIndex === 0) {
        return 'scaleX(' + originalScale + ')';
      }

      // if the slide process has completed the active slide is equal to the totelsteps
      // else it's equal to the current slide (activeIndex is zero based)
      var activeSlide = completed ? totalSteps : swiper.activeIndex + 1;

      return 'scaleX(' + (activeSlide * originalScale) + ')';
    };

    /**
     * handleStepButtons display/hide the buttons and disables/enable the inputs
     * @returns {void}
     */
    var handleStepButtons = function () {
      if (swiper.activeIndex === 0) {
        $notNewLink.removeClass('hidden');
        $backButton.addClass('hidden');
      } else {
        $notNewLink.addClass('hidden');
        $backButton.removeClass('hidden');
      }
    };

    /**
     * validateStepOne send the request to validate step one of account creation
     * @returns {void}
     */
    var validateStepOne = function () {
      $form.clearFormErrors();
      $inputs.prop('disabled', false);

      $form.ajaxSubmit({
        url: '/register/step-1/',
        dataType: 'json',
        success: function (data) {
          $form.updateCsrfToken();
          var eventData;

          if (data.success) {
            swiper.slideNext();
            handleStepButtons(swiper, $inputs);
            updateProgressBar();
            updateSwiperContainerClass();

            /**
             * mParticle sendEvent - Click Sign Up CTA 1 - Success
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Success',
              'Location': location,
              'Step': 1
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);
            $nextButton.prop('disabled', false);
            return;
          } else if (data.redirect && data.error === 'error-under-13') {
            /**
             * mParticle sendEvent - Click Sign Up CTA 1 - Invalid
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'User is underage error (' + data.redirect.error + ')',
              'Location': location,
              'Step': 1
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);
            window.location.replace(data.redirect.url);
          } else {
            /**
             * mParticle sendEvent - Click Sign Up CTA 1 - Invalid
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Invalid email or password',
              'Location': location,
              'Step': 1
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);

            handleFormFieldErrors(data);
            updateInputsStates();
            $nextButton.prop('disabled', false);
          }
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          // Log mParticle Click Sign Up CTA 1 event - Response: Server Error
          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 1
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);

          // Display the Error Message and update the input state.
          $formError.text(genericErrorMessage);
          updateInputsStates(false);
          $nextButton.prop('disabled', false);
        }
      });
    };

    /**
     * validateStepTwo send the request to validate step two of account creation
     * @returns {void}
     */
    var validateStepTwo = function () {
      $form.clearFormErrors();
      $inputs.prop('disabled', false);

      $form.ajaxSubmit({
        url: '/register/step-2/',
        dataType: 'json',
        success: function (data) {
          var eventData;

          $form.updateCsrfToken();

          if (data.success) {
            // Get terms and conditions
            SC.authentication.getTerms();
            swiper.slideNext();
            handleStepButtons(swiper, $inputs);
            updateProgressBar();
            updateSwiperContainerClass();
            $nextButton.hide();
            $doneButton.show();

            // set defaults for checkbox
            $optSellingContainer.hide();
            $optMarketingContainer.hide();

            // check for cases where it is a string (we evaluate falsy above)
            if (data.checkbox && data.checkbox !== false) {
              displayOptCheckbox(data.checkbox);
              // modify height of 3rd step so buttons are clear of checkbox
              $('.swiper-container--third-slide').height(550);
            }

            /**
             * mParticle sendEvent - Click Sign Up CTA 2 - Success
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Success',
              'Location': location,
              'Step': 2
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 2', 'navigation', eventData, location);
            $nextButton.prop('disabled', false);

            return;
          }

          /**
           * mParticle sendEvent - Click Sign Up CTA 2 - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid First Name, Last Name or Phone Number',
            'Location': location,
            'Step': 2
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 2', 'navigation', eventData, location);

          handleFormFieldErrors(data);
          updateInputsStates();
          $nextButton.prop('disabled', false);
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 2
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 2', 'navigation', eventData, location);

          $formError.text(genericErrorMessage);
          updateInputsStates(false);
          $nextButton.prop('disabled', false);
        }
      });
    };

    /**
     * validateStepThree send the request to validate step three of account creation
     * @returns {void}
     */
    var validateStepThree = function () {
      $form.clearFormErrors();
      $inputs.prop('disabled', false);

      $form.ajaxSubmit({
        url: '/register/step-3/',
        dataType: 'json',
        success: function (data) {
          var eventData;
          $form.updateCsrfToken();

          if (data.success) {
            $inputs.prop('disabled', false);
            updateProgressBar(true);
            updateSwiperContainerClass();
            registerNewRider();

            /**
             * mParticle sendEvent - Click Sign Up CTA 3 - Success
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Success',
              'Location': location,
              'Step': 3
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 3', 'navigation', eventData, location);

            return;
          }

          /**
           * mParticle sendEvent - Click Sign Up CTA 3 - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid Emergency Contact Name, Emergency Phone Number or Terms & Conditions',
            'Location': location,
            'Step': 3
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 3', 'navigation', eventData, location);

          handleFormFieldErrors(data);
          updateInputsStates();
          $doneButton.prop('disabled', false);
          $nextButton.prop('disabled', false);
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 3
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 3', 'navigation', eventData, location);

          $formError.text(genericErrorMessage);
          updateInputsStates();
          $nextButton.prop('disabled', false);
        }
      });
    };

    /**
     * registerNewRider send the request to register the new rider
     * @returns {void}
     */
    var registerNewRider = function () {
      $form.clearFormErrors();
      $doneButton.prop('disabled', true);

      var capturedEmail = SC.analytics.mp.getEmailAttribute();
      $form.ajaxSubmit({
        url: '/register/',
        dataType: 'json',
        success: function (data) {
          var eventData;

          $form.updateCsrfToken();

          if (data.success) {
            var emailWasCaptured = data.rider && capturedEmail && data.rider.email === capturedEmail;
            /**
             * mParticle User Identity - setup user
             */
            // If user being registered is NOT the same that was captured previously
            if (!emailWasCaptured) {
              SC.analytics.mp.userEvent('remove');
            }

            var userEventPromise = SC.analytics.mp.userEvent('setup', data.rider_id.toString());

            userEventPromise.then(function () {
              /**
               * mParticle sendEvent - Account Creation Response - Success
               * Sends mParticle event with a label for GA Event.
               */

              eventData = {
                'Response': 'Success',
                'Location': location,
                'Step': 3
              };

              if (data.rider.do_not_sell_approved && data.rider.do_not_sell_approved === true) {
                SC.analytics.mp.setupConsent(Date.now(), '', location);
              }

              SC.analytics.mp.userEvent('attribute', data.rider.first_name.toString(), 'first_name');
              SC.analytics.mp.userEvent('attribute', 1, 'has_account');
              SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);

              if (emailWasCaptured) {
                SC.analytics.mp.sendEvent('Create Account Since Email Capture', 'navigation');
              }
            }).fail(function (error) {
              eventData = {
                'Response': 'Server Error - error: ' + error,
                'Location': location,
                'Step': 3
              };
              SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);
            }).always(function () {
              if (data.url) {
                window.location.replace(data.url);
              } else {
                window.location.reload();
              }
            });

            return;
          }

          /**
           * mParticle sendEvent - Account Creation Response - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid email, password, First Name, Last Name or Phone Number, Emergency Contact Name, Emergency Phone Number or Terms & Conditions',
            'Location': location,
            'Step': 'Step 3'
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);

          handleFormFieldErrors(data);
          $doneButton.prop('disabled', false);
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 3
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);

          $formError.text(genericErrorMessage);
          updateInputsStates();
          $doneButton.prop('disabled', false);
        }
      });
    };

    /**
     * handles the form field errors for each slide
     *
     * @param {object} data data returned from ajax request
     * @returns {void}
     */
    var handleFormFieldErrors = function (data) {
      var $activeSlide = $('.account-creation__form__swiper__slide--active');

      if (data.fieldErrors) {
        $form.fieldErrors(data.fieldErrors);
        $activeSlide.find('.global__input__text').hide();
      }

      if (!data.fieldErrors) {
        $formError.text(data.message || genericErrorMessage);
      }
    };

    /**
     * updateInputsStates enables current step `inputs` and disables the other steps `inputs`.
     *
     * @param {object} firstActiveInput the first active input
     * @returns {void}
     */
    var updateInputsStates = function (firstActiveInput) {
      var focusFirstActiveInput = (typeof firstActiveInput !== 'undefined') ? firstActiveInput : true;
      $inputs.prop('disabled', true);
      var $activeInputs = $('.account-creation__form__swiper__slide--active input');

      // This is to take out of the keyword tab selections the disable flags div's
      $('.account-creation__form__swiper__slide .selected-flag').each(function () {
        $(this).attr('tabindex', '-1');
      });

      $('.account-creation__form__swiper__slide--active .selected-flag').each(function () {
        var $selectedFlag = $(this);
        $selectedFlag.attr('tabindex', $selectedFlag.attr('tabindex-bck'));
      });

      $activeInputs.prop('disabled', false);
      if (focusFirstActiveInput) {
        $activeInputs.first().focus();
      }
    };

    /**
     * updates the progressbar based on the step we're on.
     *
     * @param {boolean} completed indicating if we've completed the swiping and exiting(done button)
     * @returns {void}
     */
    var updateProgressBar = function (completed) {
      if (!$progressBar) {
        return;
      }

      $progressBar.css('transform', getScaleX(completed));
    };

    var updateSwiperContainerClass = function () {
      if (swiper.activeIndex === 2) {
        swiper.container.addClass('swiper-container--third-slide');
      } else {
        swiper.container.removeClass('swiper-container--third-slide');
      }
    };

    /**
     * On the signup page, load the date of birth <select> options for month, day, and year
     *
     * @return {void}
     */
    var loadDobSelectOption = function () {
      var date = new Date();
      var fullYear = date.getFullYear();
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      for (var i = 0; i < months.length; i++) {
        var selectedMonth = i === 0 ? ' selected' : '';
        $dobMonthInput.append('<option value="' + parseInt(i + 1, 10) + '"' + selectedMonth + '>' + months[i] + '</option>');
      }

      for (var n = (fullYear - 110); n <= fullYear; n++) {
        var selectedYear = n === fullYear ? ' selected' : '';
        $dobYearInput.append('<option value="' + n + '"' + selectedYear + '>' + n + '</option>');
      }

      refreshDobDayInput();
    };

    /**
     * Add appropriate attributes to the checkbox field so submission works
     * opt_in_selling is always true by default, and set to 0 (false) depending on logic for children
     *
     * @param {string} checkboxName Either `opt_in_selling` or `opt_out_marketing`
     * @return {void}
     */
    var displayOptCheckbox = function (checkboxName) {
      $('#optin_optout_checkbox').css('display', 'block');

      $optSellingCheckbox.val('1');
      $optSellingCheckbox.prop('checked', 'checked');

      $optMarketingCheckbox.val('0');
      $optMarketingCheckbox.removeProp('checked');

      /* eslint indent: ["error", 2, { "SwitchCase": 1 }]*/
      switch (checkboxName) {
        case 'opt_in_selling':
          $optSellingContainer.css('display', 'block');

          $optSellingCheckbox.val('0');
          $optSellingCheckbox.removeProp('checked');
          break;
        case 'opt_out_marketing':
          $optMarketingContainer.css('display', 'block');
          break;
        default:
          console.error('No appropriate option found.');
          break;
      }
    };

    var checkAgeEligibility = function () {
      if (!isOverEighteen()) {
        $formError.text('If you are under 18, registration must be completed in person, at one of our studios, ' +
          'accompanied by a parent or guardian who must sign a Minor New Rider Waiver Form for you. After this is complete, ' +
          'you may sign up for SoulCycle classes online. Riders must be at least at least 12 years of age, meet the minimum height requirement of 4\'11"');
      } else {
        $formError.text('');
      }
    };

    // Nette forms is causing an override cause of the swiper, target the phone numbers directly
    $('#phone-input, #emergency_contact_phone-input').on('click', function () {
      $(this).focus();
    });

    $nextButton.on('click', function () {
      $nextButton.prop('disabled', true);
      var currentStep = swiper.activeIndex + 1;
      $doneButton.hide();
      $form.clearFormErrors();

      if (currentStep === 1) {
        validateStepOne();
      } else if (currentStep === 2) {
        validateStepTwo();
      } else {
        $nextButton.hide();
        $doneButton.show();
      }
      $('.global__input__text').show();
    });

    // Handles the `back` button logic for step 2 and step 3
    $backButton.on('click', function () {
      $form.updateCsrfToken();
      $nextButton.show();
      $doneButton.hide();
      $form.clearFormErrors();
      swiper.slidePrev();
      handleStepButtons(swiper, $inputs);
      updateProgressBar();
      updateSwiperContainerClass();

      var currentStep = swiper.activeIndex + 1;
      var eventData = {
        'Location': location,
        'Context': 'Sign Up',
        'Step': currentStep
      };
      SC.analytics.mp.sendEvent('Click Back', 'navigation', eventData, location);
      $('.global__input__text').show();
    });

    // Handles the `done` button logic to register the new rider
    $doneButton.on('click', function () {
      validateStepThree();
      $doneButton.prop('disabled', true);
    });

    $notNewLink.on('click', function () {
      var eventData = {
        'Location': location,
        'Context': 'Sign Up',
        'Step': 1
      };
      SC.analytics.mp.sendEvent('Click to Log In', 'navigation', eventData, location);
    });

    $inputs.on('keydown', $form, function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (swiper.activeIndex < 2) {
          $nextButton.trigger('click');
        } else {
          $doneButton.trigger('click');
        }
      }
    });

    $dobDayInput.change(function () {
      checkAgeEligibility();
    });

    $dobMonthInput.change(function () {
      refreshDobDayInput();
      checkAgeEligibility();
    });

    $dobYearInput.change(function () {
      refreshDobDayInput();
      checkAgeEligibility();
    });

    $countryInput.change(function () {
      window.soulcycle.countryCode = $(this).val();

      loadStatesAndProvinces();
      updateIntlPhoneFlag();
    });

    $optSellingLabel.click(function () {
      toggleCheckbox('opt_in_selling');
    });

    $optSellingSpan.click(function () {
      toggleCheckbox('opt_in_selling');
    });

    $optMarketingLabel.click(function () {
      toggleCheckbox('opt_out_marketing');
    });

    $optMarketingSpan.click(function () {
      toggleCheckbox('opt_out_marketing');
    });

    $dobPlaceholder.focus(function () {
      // set dobPlaceholder to false so validation rules pass. This input is only used for the frontend
      $dobPlaceholder.parent().css('display', 'none');
      $dobPlaceholder.val('false');
      loadDobSelectOption();
      $('.dob_group_ctr').css('display', 'flex');
    });

    $locationPlaceholder.focus(function () {
      // set locationPlaceholder to false so validation rules pass. This input is only used for the frontend
      $locationPlaceholder.parent().css('display', 'none');
      $locationPlaceholder.val('false');
      loadStatesAndProvinces();
      $('.location_group_ctr').css('display', 'flex');
    });

    updateProgressBar();

    // We need to wait for intl phone inputs to be initialized
    setTimeout(function () {
      $('.account-creation__form__swiper__slide .selected-flag').each(function () {
        var $selectedFlag = $(this);
        $selectedFlag.attr('tabindex-bck', $selectedFlag.attr('tabindex'));
        $selectedFlag.attr('tabindex', '-1');
      });
      updateInputsStates(false);
    }, 300);
  };

  init();

  return api;
}());
